export const BASE_URL = "https://api.camp-coding.site/";
